// @flow

import TripAdvisorReviews from './trip-advisor-reviews'

export default TripAdvisorReviews
